<!-- Modal -->
<div class="modal fade" [class.show]="isVisible" [style.display]="isVisible ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-warehouse me-2"></i>
          {{ getActionTitle() }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Informações do Estoque -->
        <div class="stock-info-section">
          <h6 class="section-title">
            <i class="fas fa-box me-2"></i>
            Informações do Estoque
          </h6>
          <div class="stock-info-grid">
            <div class="info-item">
              <label class="info-label">Código</label>
              <div class="info-value">{{ stock?.code }}</div>
            </div>
            <div class="info-item">
              <label class="info-label">Nome</label>
              <div class="info-value">{{ stock?.name }}</div>
            </div>
            <div class="info-item">
              <label class="info-label">Almoxarifado Atual</label>
              <div class="info-value">
                <span [class]="stock?.warehouseId ? 'status-linked' : 'status-unlinked'">
                  <i class="fas fa-warehouse me-1"></i>
                  {{ getCurrentWarehouseName() }}
                </span>
              </div>
            </div>
            <div class="info-item">
              <label class="info-label">Localização Atual</label>
              <div class="info-value">
                <span [class]="stock?.location ? 'status-linked' : 'status-unlinked'">
                  <i class="fas fa-map-marker-alt me-1"></i>
                  {{ stock?.location || 'Não definida' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Descrição da Ação -->
        <div class="action-description-section">
          <div class="info-banner">
            <i class="fas fa-info-circle"></i>
            <span>{{ getActionDescription() }}</span>
          </div>
        </div>

        <!-- Seleção do Tipo de Ação -->
        <div class="action-selection-section">
          <h6 class="section-title">
            <i class="fas fa-cogs me-2"></i>
            Tipo de Operação
          </h6>
          <div class="action-options">
            <div class="action-option" 
                 [class.selected]="actionType === 'assign'"
                 [class.disabled]="false"
                 (click)="setActionType('assign')">
              <div class="option-header">
                <div class="option-icon">
                  <i class="fas fa-link"></i>
                </div>
                <div class="option-content">
                  <h6 class="option-title">Vincular</h6>
                  <p class="option-description">Vincular a um almoxarifado</p>
                </div>
                <div class="option-radio">
                  <input type="radio" name="actionType" value="assign" [checked]="actionType === 'assign'">
                </div>
              </div>
            </div>

            <div class="action-option" 
                 [class.selected]="actionType === 'transfer'"
                 [class.disabled]="!stock?.warehouseId"
                 (click)="stock?.warehouseId && setActionType('transfer')">
              <div class="option-header">
                <div class="option-icon">
                  <i class="fas fa-exchange-alt"></i>
                </div>
                <div class="option-content">
                  <h6 class="option-title">Transferir</h6>
                  <p class="option-description">Transferir para outro almoxarifado</p>
                </div>
                <div class="option-radio">
                  <input type="radio" name="actionType" value="transfer" 
                         [checked]="actionType === 'transfer'"
                         [disabled]="!stock?.warehouseId">
                </div>
              </div>
            </div>

            <div class="action-option" 
                 [class.selected]="actionType === 'unassign'"
                 [class.disabled]="!stock?.warehouseId"
                 (click)="stock?.warehouseId && setActionType('unassign')">
              <div class="option-header">
                <div class="option-icon">
                  <i class="fas fa-unlink"></i>
                </div>
                <div class="option-content">
                  <h6 class="option-title">Desvincular</h6>
                  <p class="option-description">Remover vinculação</p>
                </div>
                <div class="option-radio">
                  <input type="radio" name="actionType" value="unassign" 
                         [checked]="actionType === 'unassign'"
                         [disabled]="!stock?.warehouseId">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulário -->
        <div class="form-section" *ngIf="actionType !== 'unassign'">
          <h6 class="section-title">
            <i class="fas fa-edit me-2"></i>
            Configurações
          </h6>
          <form [formGroup]="form">
            <div class="form-grid">
              <div class="form-group">
                <label for="warehouseId" class="form-label">
                  <i class="fas fa-warehouse me-1"></i>
                  Almoxarifado *
                </label>
                <select 
                  id="warehouseId"
                  class="form-select"
                  formControlName="warehouseId"
                  [class.is-invalid]="form.get('warehouseId')?.invalid && form.get('warehouseId')?.touched">
                  <option value="">Selecione um almoxarifado...</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.name }} ({{ warehouse.code }})
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="form.get('warehouseId')?.invalid && form.get('warehouseId')?.touched">
                  Selecione um almoxarifado
                </div>
              </div>
              
              <div class="form-group">
                <label for="location" class="form-label">
                  <i class="fas fa-map-marker-alt me-1"></i>
                  Localização
                </label>
                <input 
                  type="text" 
                  id="location"
                  class="form-control"
                  formControlName="location"
                  placeholder="Ex: Prateleira A1, Gaveta 3"
                  [class.is-invalid]="form.get('location')?.invalid && form.get('location')?.touched">
                <div class="invalid-feedback" *ngIf="form.get('location')?.invalid && form.get('location')?.touched">
                  Localização inválida
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Confirmação para Desvincular -->
        <div *ngIf="actionType === 'unassign'" class="unassign-confirmation-section">
          <div class="warning-banner">
            <i class="fas fa-exclamation-triangle"></i>
            <div class="warning-content">
              <h6>Atenção!</h6>
              <p>Esta ação irá remover a vinculação deste estoque com o almoxarifado atual. O estoque ficará sem localização definida.</p>
            </div>
          </div>
        </div>

        <!-- Resumo da Operação -->
        <div class="operation-summary-section" *ngIf="actionType !== 'unassign' && form.get('warehouseId')?.value">
          <h6 class="section-title">
            <i class="fas fa-list-check me-2"></i>
            Resumo da Operação
          </h6>
          <div class="summary-card">
            <div class="summary-grid">
              <div class="summary-item">
                <div class="summary-icon">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <div class="summary-content">
                  <label class="summary-label">De:</label>
                  <div class="summary-value">{{ getCurrentWarehouseName() }}</div>
                </div>
              </div>
              <div class="summary-item">
                <div class="summary-icon">
                  <i class="fas fa-arrow-right"></i>
                </div>
                <div class="summary-content">
                  <label class="summary-label">Para:</label>
                  <div class="summary-value">{{ getSelectedWarehouseName() }}</div>
                </div>
              </div>
              <div class="summary-item" *ngIf="form.get('location')?.value">
                <div class="summary-icon">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="summary-content">
                  <label class="summary-label">Nova Localização:</label>
                  <div class="summary-value">{{ form.get('location')?.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="closeModal()"
          [disabled]="isSubmitting">
          <i class="fas fa-times me-2"></i>
          Cancelar
        </button>
        <button 
          type="button" 
          class="btn btn-primary"
          (click)="submit()"
          [disabled]="!isFormValid() || isSubmitting">
          <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
          <i class="fas fa-check me-2" *ngIf="!isSubmitting"></i>
          {{ getActionButtonText() }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade" [class.show]="isVisible" *ngIf="isVisible"></div>
